import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from 'sonner';

interface ExportDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  exportName: string;
  setExportName: (name: string) => void;
  onExport: () => void;
}

export const ExportDialog: React.FC<ExportDialogProps> = ({
  open,
  onOpenChange,
  exportName,
  setExportName,
  onExport,
}) => {
  const handleExport = () => {
    if (!exportName.trim()) {
      toast.error('Please enter a name for the export');
      return;
    }
    onExport();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Export to Excel</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="exportName" className="text-right">
              Export Name
            </Label>
            <Input
              id="exportName"
              value={exportName}
              onChange={(e) => setExportName(e.target.value)}
              className="col-span-3"
              placeholder="Enter export name"
              autoFocus
            />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={handleExport}>Export</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};